import { render, staticRenderFns } from "./CourierDocumentation.vue?vue&type=template&id=696904fc"
import script from "./CourierDocumentation.vue?vue&type=script&lang=js"
export * from "./CourierDocumentation.vue?vue&type=script&lang=js"
import style0 from "./CourierDocumentation.vue?vue&type=style&index=0&id=696904fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports